import { fetchAll, httpGET, httpDELETE, json } from './utils.js';
import { ACTIONS } from '../const';
import { selectContent } from '../selectors/content';
import { createAction } from 'redux-actions';

const CONTENT_ROOT = '/api/v4/content/';

const addContent = c => async dispatch => {
    let content = c;

    const cover_override = content.link_cover_override;
    if (cover_override != null) {
        if (cover_override.split(':')[0] === 'vimeo') {
            const [protocol, empty, vimeoId] = cover_override.split('/');
            void (protocol, empty);

            const url = `https://vimeo.com/api/v2/video/${vimeoId}.json`;

            const options = {
                // # this cross site request can't use credentials
                credentials: undefined,
            };
            const link_cover_override = await httpGET(url, options)
                .then(json)
                .then(([item]) => item.thumbnail_large);

            // # fetch will find the real https?: URL and change
            // # link_cover_override
            content = {
                ...content,
                link_cover_override,
            };
        }
    }

    dispatch({
        type: ACTIONS.ADD_CONTENT,
        manifest: content,
    });
};

export const zoomInto = (content, scale, scaleCenter = null) => {
    return {
        type: ACTIONS.SET_CONTENT_SETTINGS,
        content,
        settings: {
            scale,
            scaleCenter,
        },
    };
};

export const fetchContentForSection = section => dispatch => {
    return fetchAll(
        CONTENT_ROOT + `?section=${section.id}&limit=9000`,
        data => {
            Promise.all(data.objects.map(c => dispatch(addContent(c))));
        }
    );
};

export const deleteContent = content => dispatch => {
    dispatch({
        type: ACTIONS.DELETE_CONTENT,
        payload: { content },
    });
    return httpDELETE(content.resource_uri);
};

export const refreshContent = id => (dispatch, getState) => {
    return httpGET(`${CONTENT_ROOT}${id}/`)
        .then(json)
        .then(manifest => {
            return Promise.all([dispatch(addContent(manifest))]);
        })
        .then(() => {
            return selectContent(getState(), id);
        });
};

export const getContent = id => (dispatch, getState) => {
    const content = selectContent(getState(), id);
    if (content != null) {
        return Promise.resolve(content);
    }

    return dispatch(refreshContent(id));
};

export const setOrigin = createAction(ACTIONS.SET_ORIGIN);



// WEBPACK FOOTER //
// ./src/actions/content.js